import React, { memo, useMemo } from 'react';
import Reactions from '@atlassian/jira-issue-view-common/src/component/reactions/reactions-view.tsx';
import { componentWithFG } from '@atlassian/jira-feature-gate-component/src/index.tsx';
import { useContextStateIssueAri, useReactionsStateIsActive } from '../../../state/context.tsx';
import { CommentReactions } from './main.tsx';

type ConnectedCommentReactionsProps = {
	showQuickReactions?: boolean;
	onReactionSuccess?: (commentId: string) => void;
};

type ConnectedCommentReactionsPropsNew = {
	commentId?: string;
	showQuickReactions?: boolean;
	onReactionSuccess?: (commentId: string) => void;
};

const ConnectedCommentReactionsOld = memo(
	({ showQuickReactions, onReactionSuccess }: ConnectedCommentReactionsProps) => {
		const [{ issueAri, commentAri }] = useContextStateIssueAri();
		const [{ isActive }] = useReactionsStateIsActive();

		const props = useMemo(
			() => ({
				visible: isActive,
				issueAri,
				commentAri,
				showQuickReactions,
				onReactionSuccess,
			}),
			[isActive, issueAri, commentAri, showQuickReactions, onReactionSuccess],
		);

		const MemoizedCommentReactions = memo(CommentReactions);

		return <MemoizedCommentReactions {...props} />;
	},
);

const ConnectedCommentReactions = memo(
	({ showQuickReactions, onReactionSuccess, commentId }: ConnectedCommentReactionsPropsNew) => {
		return (
			<Reactions
				commentId={commentId}
				showQuickReactions={showQuickReactions}
				onReactionSuccess={onReactionSuccess}
			/>
		);
	},
);

export default componentWithFG(
	'improve_issue_view_comment_reaction_buttons',
	ConnectedCommentReactions,
	ConnectedCommentReactionsOld,
);
